import { createControlFn } from "../create-control-fn"

const controlEmailFieldFn = createControlFn({
  filterValueCb: (value) => !/[^0-9a-zA-Z-_.@]/.test(value),
  onChangeCb(fieldOnChange, value) {
    // Convert email to lowercase on change
    fieldOnChange(value.toLowerCase())
  },
})

export { controlEmailFieldFn }
